/** Copyright (c) 2020 T. Rowe Price. All rights reserved. */

import { createLogic } from 'redux-logic';

import { titleCase } from 'services/Formats';
import { addToast } from 'state/toast/ToastActions';
import { analyticsActionSuccess } from 'state/analytics/AnalyticsActions';
import {RECEIVED_UPDATE_BENEFICIARIES} from "../beneficiaries/BeneficiaryActions";
import {beneficiariesEnabled} from "../../services/FeatureFlags";
import {isEducationSavingsAccount} from 'services/AccountTypes';
import { replaceStringIfEducationSavings } from 'services/BeneficiaryV2';

const BeneficiariesV2Logic = createLogic({
  type: [RECEIVED_UPDATE_BENEFICIARIES],

  process({ action }, dispatch, done) {
    const { beneficiaries } = action;
    const accountType = beneficiaries && beneficiaries[0] && beneficiaries[0].accountDescriptor && beneficiaries[0].accountDescriptor.accountTypeId;
    const isEducationSavings = isEducationSavingsAccount(accountType);
    if (beneficiariesEnabled()) {
      // dispatch user message
      if (action.actionType === "add") {
        dispatch(addToast(true, replaceStringIfEducationSavings('Beneficiaries added', isEducationSavings)));
      }
      if (action.actionType === "update") {
        dispatch(addToast(true, replaceStringIfEducationSavings('Beneficiaries updated', isEducationSavings)));
      }
      if (action.actionType === "delete") {
        dispatch(addToast(true, replaceStringIfEducationSavings('Beneficiaries deleted', isEducationSavings)));
      }

    // dispatch analytics message
    const type = titleCase(action.type.slice('RECEIVED_'.length), '_', '');
    dispatch(analyticsActionSuccess('ProfPref', type));
  }
    done();
  }


});

export default BeneficiariesV2Logic;
